import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { OrdersPage } from '@/features/service-agreements/orders-page';

/** The new-car service-agreement orders. The list endpoint requires `service-agreement:read`. */
export const Route = createFileRoute('/_app/service-agreement/orders/new-car')({
  staticData: { featureKey: 'service-agreements' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'service-agreements',
      permissions: ['service-agreement:read'],
    }),
  component: () => <OrdersPage type="NEW_CAR" />,
});
